// extracted by mini-css-extract-plugin
export default {"popover":"pK1dQx5VAeS05qW6ctNfZg==","mention":"QQyY0-YymlA1gjm8qaJsCA=="};